// extracted by mini-css-extract-plugin
module.exports = {"btn":"Consignment_btn__2bpA7","problem":"Consignment_problem__1QWI2","consignmentDetails":"Consignment_consignmentDetails__39__Z","buttonGroup":"Consignment_buttonGroup__1WAAl"};